import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-position: top center;
`;

export const Title = styled.h1`
  display: inline;
  color: #434e59;
  font-size: 20px;
  font-weight: 600;
  line-height: 28px;
  margin-right: 12px;
`;

export const Desc = styled.div`
  color: rgba(0, 0, 0, 0.45);
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 20px;
`;

export const Actions = styled.div`
  button:not(:last-child) {
    margin-right: 8px;
  }
`;
